import { HijriGregorianDatePickerComponent } from './hijri-gregorian-date-picker/hijri-gregorian-date-picker.component';
import { HijriDatePickerComponent } from './hijri-date-picker/hijri-date-picker.component';
import { ImprovementProcessListComponent } from './Components/improvement-plan/improvement-process-list/improvement-process-list.component';
import { ImprovementPlanProcessComponent } from './Components/improvement-plan/improvement-plan-process/improvement-plan-process.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagingComponent } from './Components/paging/paging.component';
import { NotificationComponent } from './Components/notification/notification.component';
import { ThemeModule } from '../../@theme/theme.module';
import {
  NbCardModule,
  NbInputModule,
  NbButtonModule,
  NbAlertModule,
  NbDatepickerModule,
  NbTooltipModule,
  NbIconModule,
  NbRadioModule,
} from '@nebular/theme';
import { FormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ngx-custom-validators';
import { FilePickerModule } from 'ngx-awesome-uploader';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { EmailInputComponent } from './form-inputs/email-input/email-input.component';
import { TextInputComponent } from './form-inputs/text-input/text-input.component';
import { NumberInputComponent } from './form-inputs/number-input/number-input.component';
import { TextAreaInputComponent } from './form-inputs/text-area-input/text-area-input.component';

import { PasswordInputComponent } from './form-inputs/password-input/password-input.component';
import { SelectInputComponent } from './form-inputs/select-input/select-input.component';
import { DateInputComponent } from './form-inputs/date-input/date-input.component';
import { DynamicTextInputGroupComponent } from './form-inputs/dynamic-text-input-group/dynamic-text-input-group.component';
import { MAT_DIALOG_DATA, MatDatepickerModule, MatDialogRef, MatFormFieldModule, MatInputModule, MatSelectModule } from '@angular/material';
import { MahakImprovementPlanComponent } from './Components/improvement-plan/mahak-improvement-plan/mahak-improvement-plan';
import { GregorianDatePickerComponent } from './gregorian-date-picker/gregorian-date-picker.component';
import { NgbDatepicker, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { ProcessAchievementFormComponent } from './Components/improvement-plan/renew-achievement/process-achievement-form/process-achievement-form.component';
import { ProcessDetailsComponent } from './Components/improvement-plan/renew-achievement/process-details/process-details.component';
import { RenewAchievementIndicatorComponent } from './Components/improvement-plan/renew-achievement/renew-achievement-indicator/renew-achievement-indicator.component';
import { RenewAchievementMahakComponent } from './Components/improvement-plan/renew-achievement/renew-achievement-mahak/renew-achievement-mahak.component';
import { ProcessAchievementDetailsComponent } from './Components/improvement-plan/renew-achievement/process-achievement-details/process-achievement-details.component';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploaderComponent } from './Components/file-uploader/file-uploader.component';
import { TextEditorInputComponent } from './form-inputs/text-editor-input/text-editor-input.component';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { FilterComponent } from './Components/filter/filter.component';
import { GetControlPipe } from './pipes/getControl.pipe';
import { NewFileUploaderComponent } from './Components/new-file-uploader/new-file-uploader.component';
import { FileSizePipe } from './pipes/fileSize.pipe';
import { ConfirmationDialogComponent } from './Components/confirmation-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    ThemeModule,
    NbCardModule,
    NbInputModule,
    NbButtonModule,
    NbAlertModule,
    FormsModule,
    CustomFormsModule,
    FilePickerModule,
    SelectDropDownModule,
    NbDatepickerModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    NbTooltipModule,
    NbIconModule,
    NgbDatepickerModule,
    TranslateModule,
    NbRadioModule,
    RichTextEditorAllModule,

    // SharedTranslateModule
  ],
  exports: [
    PagingComponent,
    EmailInputComponent,
    TextInputComponent,
    NumberInputComponent,
    TextAreaInputComponent,
    FilterComponent,
    MahakImprovementPlanComponent,
    PasswordInputComponent,
    SelectInputComponent,
    DateInputComponent,
    DynamicTextInputGroupComponent,
    EmailInputComponent,
    TextInputComponent,
    NumberInputComponent,
    TextAreaInputComponent,
    FileUploaderComponent,
    TextEditorInputComponent,
    GetControlPipe,
    NewFileUploaderComponent,
    HijriGregorianDatePickerComponent,
    HijriDatePickerComponent,
    ConfirmationDialogComponent,
  ],
  declarations: [
    EmailInputComponent,
    TextInputComponent,
    NumberInputComponent,
    TextAreaInputComponent,
    MahakImprovementPlanComponent,
    ImprovementProcessListComponent,
    PasswordInputComponent,
    SelectInputComponent,
    DateInputComponent,
    DynamicTextInputGroupComponent,
    PagingComponent,
    NotificationComponent,
    ImprovementPlanProcessComponent,
    HijriDatePickerComponent,
    GregorianDatePickerComponent,
    HijriGregorianDatePickerComponent,
    ProcessAchievementFormComponent,
    ProcessDetailsComponent,
    RenewAchievementIndicatorComponent,
    RenewAchievementMahakComponent,
    ProcessAchievementDetailsComponent,
    FileUploaderComponent,
    TextEditorInputComponent,
    FilterComponent,
    GetControlPipe,
    NewFileUploaderComponent,
    FileSizePipe,
    ConfirmationDialogComponent
  ],
  entryComponents: [
    ConfirmationDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: {} }
  ]
})
export class SharedModule {}
